export const QUERY_STALE_TIME = 30 * 60 * 1000; // 30 minutes in milliseconds
export const MARKET_CONFIG_QUERY_STALE_TIME = 120 * 60 * 1000; // 120 minutes in milliseconds
